import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute } from '@angular/router';
import { takeWhile } from "rxjs/operators";
import * as FileSaver from 'file-saver';

import {
    FvmsCommonService
    ,FvmsApiDtgDownloadService
} from "src/app/shared/service";
import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    templateUrl: './fvms.download.etas.main.component.html'
    ,providers: []
})
export class FvmsDownloadEtasMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    DtgListType = DtgListType;
    fileName:string;
    fileExist:boolean = false;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private activatedRoute: ActivatedRoute
        ,private fvmsApiDtgDownloadService:FvmsApiDtgDownloadService
    ) {
        this.fileName = this.activatedRoute.snapshot.queryParamMap.get("fileName");
    }

    ngOnInit() {
        this.checkFileExist();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    checkFileExist(){
        this.fvmsApiDtgDownloadService.etasFileCheck(this.fileName)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe((resCheck: any) => {
                if(resCheck.resultStatus === "ok"){
                    this.fileExist = true;
                }
            },err => {
                console.error("resCheck err",err);
            });
    }

    clickEtasFileDownload(){
        if(this.fileName){
            if(this.fileExist === true){
                this.fvmsApiDtgDownloadService.etasFileDown2(this.fileName)
                    .pipe(takeWhile(() => this.isContinue))
                    .subscribe((resDown:Blob) => {
                        FileSaver.saveAs(resDown,`${this.fileName}.zip`);
                    });
            }
        }
    }
}